import {Injectable} from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {TimeSerie} from '../Pages/time-series/model/time-series.model';
import {DataRequestItem, DataRequestItemType} from '../Pages/datarequest/model/datarequest.model';

export interface TimeSerieDataRequestInfo {
    uniqueId: string;
    identifier: string;
    correctedStartTime: Date | null;
    correctedEndTime: Date | null;
}


@Injectable({
    providedIn: 'root'
})
export class ShoppingCartService {


    constructor(private $localStorage: LocalStorageService, private $sessionStorage: SessionStorageService) {
    }

    // observe(rememberMe = true) {
    //   if (rememberMe) {
    //     this.$localStorage.observe('timeseries')
    //       .subscribe((newValue) => {
    //         // console.log(newValue);
    //       });
    //   } else {
    //     // TODO
    //   }
    // }

    addDatasetToCart(jwt, rememberMe = true) {
        if (rememberMe) {
            this.$localStorage.store('dddd', jwt);
        } else {
            this.$sessionStorage.store('dddd', jwt);
        }
    }

    addSpatialLayerToCart(titleLabel: string, uniqueId: string, description: string) {
        const dataRequestItem: DataRequestItem = {
            title: titleLabel,
            unitPrice: 2.5,
            mrcId: uniqueId,
            quantity: 1,
            subtitle: null,
            description: description,
            dateAvailability: null,
            formats: null,
            type: DataRequestItemType.GEOSPATIAL,
        };
        this.addDataRequestItemsToCart([dataRequestItem]);
    }


    addTimeSeriesFromCatalogueToCart(titleLabel: string, uniqueId: string, correctedStartTime: Date, correctedEndTime: Date, rememberMe = true) {

        const start = new Date(correctedStartTime).toISOString().split('T')[0];
        const end = new Date(correctedEndTime).toISOString().split('T')[0];

        const dataRequestItem: DataRequestItem = {
            title: titleLabel,
            unitPrice: 2.5,
            mrcId: uniqueId,
            quantity: 1,
            subtitle: null,
            description: null,
            dateAvailability: `${start} to ${end}`,
            formats: 'CSV, XLSX',
            type: DataRequestItemType.TIME_SERIES,
        };
        this.addDataRequestItemsToCart([dataRequestItem]);
    }

    addTimeSeriesByTimeSerieDataRequestInfosToCart(timeSerieDataRequestInfos: TimeSerieDataRequestInfo[]) {

        const cartitems: DataRequestItem[] = timeSerieDataRequestInfos.map((tsi) => {

            let da = null;
            if (tsi.correctedStartTime !== null && tsi.correctedEndTime !== null) {
                const start = new Date(tsi.correctedStartTime).toISOString().split('T')[0];
                const end = new Date(tsi.correctedEndTime).toISOString().split('T')[0];
                da = `${start} to ${end}`;
            }

            const dataRequestItem: DataRequestItem = {
                title: tsi.identifier,
                unitPrice: 2.5,
                mrcId: tsi.uniqueId,
                quantity: 1,
                subtitle: null,
                description: null,
                dateAvailability: da,
                formats: 'CSV, XLSX',
                type: DataRequestItemType.TIME_SERIES,
            };
            return dataRequestItem;
        });

        this.addDataRequestItemsToCart(cartitems);
    }

    addTimeSeriesToCart(timeseries: TimeSerie[], rememberMe = true) {

        const cartitems: DataRequestItem[] = timeseries.map((ts: TimeSerie) => {

            const start = new Date(ts.correctedStartTime).toISOString().split('T')[0];
            const end = new Date(ts.correctedEndTime).toISOString().split('T')[0];

            const dataRequestItem: DataRequestItem = {
                title: ts.identifier,
                unitPrice: 2.5,
                mrcId: ts.uniqueId,
                quantity: 1,
                subtitle: null,
                description: null,
                dateAvailability: `${start} to ${end}`,
                formats: 'CSV, XLSX',
                type: DataRequestItemType.TIME_SERIES,
            };
            return dataRequestItem;
        });

        this.addDataRequestItemsToCart(cartitems);
    }


    retrieveCart(rememberMe = true): DataRequestItem[] {
        if (rememberMe) {
            const storageDataRequestItems: DataRequestItem[] = this.$localStorage.retrieve('dataRequestItems');
            return storageDataRequestItems;
        } else {
            // TODO
        }
    }

    removeFromCart(cartitem: DataRequestItem, rememberMe = true) {
        if (rememberMe) {
            const storageDataRequestItems: DataRequestItem[] = this.$localStorage.retrieve('dataRequestItems');
            const filtered = storageDataRequestItems.filter((item: DataRequestItem) => {
                return item.mrcId !== cartitem.mrcId;
            });

            this.$localStorage.store('dataRequestItems', filtered);
        } else {
            // TODO
        }
    }

    addDataRequestItemsToCart(cartitems: DataRequestItem[], rememberMe = true) {
        if (rememberMe) {
            const storageDataRequestItems: DataRequestItem[] = this.$localStorage.retrieve('dataRequestItems');
            if (storageDataRequestItems && storageDataRequestItems.length > 0) {

                const filtered = cartitems.filter((item: DataRequestItem) => {
                    // TODO: fix this for giai
                    return !storageDataRequestItems.map((p: DataRequestItem) => p.mrcId).includes(item.mrcId);
                });


                storageDataRequestItems.push(...filtered);
                this.$localStorage.store('dataRequestItems', Array.from(new Set(storageDataRequestItems)));
            } else {
                this.$localStorage.store('dataRequestItems', cartitems);
            }

        } else {
            // TODO
        }
    }
}
